import { Injectable, signal } from '@angular/core';

/**
 * Stato del modale "Release Timeline". Signal semplice open/close.
 * Il component `<app-release-timeline-modal>` è montato a livello
 * di AppComponent e reagisce a questo signal.
 */
@Injectable({ providedIn: 'root' })
export class ReleaseTimelineModalService {
  /** True se il modale è visibile. */
  readonly isOpen = signal<boolean>(false);

  open(): void {
    this.isOpen.set(true);
  }

  close(): void {
    this.isOpen.set(false);
  }

  toggle(): void {
    this.isOpen.update((v) => !v);
  }
}
